export default "__VITE_ASSET__DK3R598B__"